import axios from '@/libs/api.request'

const ugdMessageService = {
  // 预约待确认列表
  page (params) {
    return axios.request({
      url: '/message/ugd/page',
      data: params,
      method: 'POST'
    })
  },
  read (msgId) {
    return axios.request({
      url: '/message/ugd/read',
      params: { msgId: msgId },
      method: 'PUT'
    })
  },
  readAll () {
    return axios.request({
      url: '/message/ugd/read/all',
      method: 'PUT'
    })
  }
}

export default ugdMessageService
